import { SignIn, useAuth } from '@clerk/clerk-react'
import { Key, LockKeyhole, Shield, User } from 'lucide-react'
import { useEffect } from 'react'

/**
 * Branding sidebar component for the sign-in page
 */
const SignInSidebar = () => {
  return (
    <div className="hidden flex-col justify-center items-center p-12 lg:flex lg:w-1/2 bg-primary/10">
      <div className="max-w-xl">
        <Key size={64} className="mb-8 text-primary" />
        <h1 className="mb-4 text-4xl font-bold">Welcome to Sully.ai API</h1>
        <p className="mb-6 text-xl text-muted-foreground">
          Sign in to access your API dashboard and manage your health AI
          integration.
        </p>

        <div className="mt-8 space-y-4">
          <h3 className="text-xl font-semibold">
            Your API dashboard provides:
          </h3>
          <ul className="space-y-3">
            <li className="flex items-center">
              <div className="p-1 mr-3 rounded-full bg-primary/20">
                <LockKeyhole size={16} className="text-primary" />
              </div>
              <span>Secure API key management</span>
            </li>
            <li className="flex items-center">
              <div className="p-1 mr-3 rounded-full bg-primary/20">
                <Shield size={16} className="text-primary" />
              </div>
              <span>Usage monitoring & analytics</span>
            </li>
            <li className="flex items-center">
              <div className="p-1 mr-3 rounded-full bg-primary/20">
                <User size={16} className="text-primary" />
              </div>
              <span>Team access controls</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

/**
 * Main sign-in component that includes sidebar and clerk authentication
 */
export const SignInFeature = () => {
  return (
    <div className="flex w-full h-screen bg-background">
      <SignInSidebar />
      {window.env?.CLERK_ENABLED ? <ClerkSignInPage /> : <StandardSignInPage />}
    </div>
  )
}

/**
 * Clerk-powered sign-in component
 */
function ClerkSignInPage() {
  const { signOut, isSignedIn } = useAuth()

  useEffect(() => {
    if (isSignedIn) {
      void signOut()
    }
  }, [isSignedIn, signOut])

  return (
    <div className="flex flex-col justify-center items-center p-6 w-full lg:w-1/2 md:p-12">
      <SignIn withSignUp={true} />
    </div>
  )
}

/**
 * Fallback sign-in for when Clerk is not enabled
 */
function StandardSignInPage() {
  return (
    <div className="flex flex-col justify-center items-center p-6 w-full lg:w-1/2 md:p-12">
      <div className="w-full max-w-md">
        <h2 className="mb-4 text-2xl font-bold">Sign In</h2>
        <p className="mb-2 text-muted-foreground">
          Authentication is not configured for sign in.
        </p>
      </div>
    </div>
  )
}
